<template lang="pug">
el-checkbox(v-model="batchAll", :disabled="disabled", :indeterminate="indeterminate")
  slot
</template>
<script>
export default {
  props: {
    idKey: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    list: { type: Array, default: () => [] }
  },
  data() {
    return {};
  },
  computed: {
    keyList() {
      const { idKey } = this;
      return this.list.map((item) => (idKey ? item[idKey] : item));
    },
    checked: {
      get() {
        return this.value || [];
      },
      set(list) {
        this.$emit("input", list || []);
      }
    },
    indeterminate() {
      const { checked, keyList } = this;
      return checked.length > 0 && keyList.some((id) => checked.indexOf(id) === -1);
    },
    batchAll: {
      get() {
        const { checked, keyList } = this;
        return checked.length > 0 && keyList.every((id) => checked.indexOf(id) > -1);
      },
      set(val) {
        const { keyList } = this;
        let checked = [];
        if (val) checked = [...keyList];
        else checked = [];
        this.checked = checked;
      }
    }
  },
  methods: {
    getKey(item) {
      const { idKey } = this;
      return idKey ? item[idKey] : item;
    },
    invertBatch() {
      const { keyList, checked } = this;
      this.checked = keyList.filter((id) => checked.indexOf(id) === -1);
    }
  }
};
</script>
